import { createSlice } from "@reduxjs/toolkit";
import storage from "redux-persist/lib/storage";
import { UserDetails } from "../../modules/client/userDetails";

interface LoggedInUserDetails {
  loggedInUserDetails?: UserDetails;
}

const initialState: LoggedInUserDetails = {
  loggedInUserDetails: undefined,
};

const authenticatedUserSlice = createSlice({
  name: "authenticatedUserSlice",
  initialState,
  reducers: {
    saveAuthenticatedUserDetails: (state, action) => {
      if (!!action.payload) {
        const userDetails: UserDetails = action.payload;

        state.loggedInUserDetails = userDetails;
      }
    },
  },
});

export const { saveAuthenticatedUserDetails } = authenticatedUserSlice.actions;

export const persistAuthConfig = {
  version: 1,
  key: "mpg_next_admin_auth_v1",
  storage,
  whitelist: ["authenticatedUserSlice"],
};

export default authenticatedUserSlice.reducer;
